<script lang="ts">
    import { onDestroy, onMount } from 'svelte'
    import { fade } from 'svelte/transition'

    import { gettext as _ } from 'hydria/services/gettext'

    import type { IAddressGroup } from 'wdom/services/contacts'

    import OrderAddressDisplay from './OrderAddressDisplay.svelte'

    interface Props {
        addresses: IAddressGroup[]
        selectedId: string | undefined | null
        modified: boolean
        close: () => void
        apply: (v: IAddressGroup) => void
    }

    let { addresses, selectedId, modified, close, apply }: Props = $props()

    onDestroy(() => {
        if (document.documentElement.classList.contains('modal-open')) {
            document.documentElement.classList.remove('modal-open')
        }
    })
    onMount(() => {
        if (!document.documentElement.classList.contains('modal-open')) {
            document.documentElement.classList.add('modal-open')
        }
    })
</script>

<svelte:window
    onkeydown={(e) => {
        if (e.key === 'Escape') {
            close()
        }
    }}
/>

<div class="modal" role="dialog" transition:fade={{ duration: 250 }}>
    <div class="modal-dialog modal-lg">
        <div class="modal-content">
            <div class="modal-header text-bg-primary">
                <div>{$_('Select an address')}</div>
            </div>
            <div class="modal-body modal-group">
                <div class="address-container">
                    {#each addresses as agroup}
                        <div class="address-box" class:is-selected={selectedId && selectedId == agroup.id} class:is-modified={selectedId && modified}>
                            <p class="address-title">{agroup.source.title}</p>
                            {#if agroup.source.comment}
                                <p class="address-source-comment">{agroup.source.comment}</p>
                            {/if}
                            <OrderAddressDisplay address={agroup.source} />

                            <div class="fill"></div>
                            <div class="address-select"><button type="button" class="btn btn-primary" onclick={() => apply(agroup)} disabled={Boolean(selectedId && selectedId == agroup.id && !modified)} class:btn-warning={selectedId && selectedId == agroup.id && modified}>{$_('Select')}</button></div>
                        </div>
                    {/each}
                </div>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-outline-secondary" onclick={() => close()}>{$_('Cancel')}</button>
            </div>
        </div>
    </div>
    <div class="modal-backdrop" onclick={() => close()} aria-hidden="true"></div>
</div>
